/* 🤖 this file was generated by svg-to-ts */
export const emperorIconLocationPin2: {
  name: 'location_pin_2';
  data: string;
} = {
  name: 'location_pin_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M12 12c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3 -1.346 3-3 3Zm0-4c-.56 0-1 .44-1 1 0 .55.44 1 1 1 .55 0 1-.45 1-1 0-.56-.45-1-1-1Z"/><path d="M12 22.667c-2.36-3.15-7-9.74-7-13.67 0-3.86 3.14-7 7-7s7 3.14 7 7c0 3.936-4.65 10.521-7 13.66ZM12 4C9.24 4 7 6.24 7 9c0 2.59 3.1 7.58 5 10.29 1.89-2.71 5-7.702 5-10.3 0-2.76-2.25-5-5-5Z"/></g></svg>`,
};
